import {Component} from '@angular/core';

@Component({
  selector: 'app-modal-supplier',
  templateUrl: './modal-supplier.component.html',
  styleUrls: ['./modal-supplier.component.scss']
})
export class ModalSupplierComponent {
  public isModalSupplierShow: boolean = false;
  public isDarkBackground: boolean = false;

  openModalSupplierShow() {
    this.isModalSupplierShow = true;
    this.isDarkBackground = true;
  }

  closeModal() {
    this.isModalSupplierShow = false;
    this.isDarkBackground = false;
  }
}
